var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/cell_phone/index.js
 ** module id = 594
 ** module chunks = 0
 **/